export default class Inscricao {
  constructor(
    matricula_id,
    endereco,
    particularidades,
    membros,
    transporte_proprio,
    vulnerabilidade_social,
    acolhimento_institucional,
    processo_judicial,
    processo_inscricao,
    observacao,
    observacao_transferencia,
    tipo,
    unidade_transferencia,
  ) {
    this.matricula_id = matricula_id;
    this.tipo = tipo || "CADASTRO";
    this.endereco = endereco
      ? {
          ...endereco,
          logradouro: endereco.rua,
          cidade_id: endereco.cidade.id,
          cep: endereco.cep.replace("-", ""),
          numero: endereco.numero || endereco.numero !== "0" || null,
        }
      : null;

    this.membros = membros.map(
      ({
        nome,
        cpf,
        certidaoNascimento: certidao_nascimento,
        pisPasep,
        workplace,
        income: renda,
        kinship,
        endereco,
      }) => ({
        nome,
        cpf: cpf ? cpf.replace(/\./gi, "").replace("-", "") : null,
        certidao_nascimento,
        pisPasep,
        local_trabalho: workplace.name,
        horario_trabalho_inicio: workplace.start,
        horario_trabalho_fim: workplace.end,
        telefone_trabalho: workplace.phone,
        renda,
        parentesco_id: kinship.id,
        endereco: endereco
          ? {
              ...endereco,
              logradouro: endereco.rua,
              cidade_id: endereco.cidade.id,
              cep: endereco.cep.replace("-", ""),
            }
          : null,
      }),
    );
    this.particularidades = particularidades;
    this.transporte_proprio = transporte_proprio;
    this.vulnerabilidade_social = vulnerabilidade_social;
    this.acolhimento_institucional = acolhimento_institucional;
    this.processo_judicial = processo_judicial;
    this.processo_inscricao_id = processo_inscricao.id;
    this.observacao = observacao;
    this.observacao_transferencia = observacao_transferencia;
    this.unidade_transferencia = unidade_transferencia;
  }
}
